var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"note-fixed"}},[_c('div',{attrs:{"id":"note-relative"}},_vm._l((_vm.notifications),function(note){return _c('div',{key:note.id,class:note.class,domProps:{"textContent":_vm._s(note.text)},on:{"click":function($event){return _vm.removeNotification(note.id)}}})}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4593c58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = null
// module chunks = 